import { render, staticRenderFns } from "./IncidentsTable.vue?vue&type=template&id=2ab8fd32&"
import script from "./IncidentsTable.vue?vue&type=script&lang=js&"
export * from "./IncidentsTable.vue?vue&type=script&lang=js&"
import style0 from "./IncidentsTable.vue?vue&type=style&index=0&id=2ab8fd32&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports